export const RowType = {
    item: 'item',
    bundle: 'bundle',
    bundle_item: 'bundle_item',
    bundle_discount: 'bundle_discount',
    subtotal: 'subtotal',
    subtitle: 'subtitle',
};
